<template>
  <div>
    <b-card
      no-body
      class="card-custom card-border">
      <b-card-body>
        <under-construction />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'StatisticsWebhooks',
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
}
</script>
